import styled from "styled-components";
import {FilterLinkDefaultBox} from "./filter-link.default.box";
import {ACTIVE} from "../../../../themes/css-global-classes";

export const FilterLinkMrGreenBox = styled(FilterLinkDefaultBox)`
    &.${ACTIVE} {
        color: ${props => props.theme.colors.textActive};
    }
    @media ${({theme}) => theme.mediaQuery.xlExact}, ${({theme}) => theme.mediaQuery.lowHeight} {
        line-height: 2.4rem;
    }
`;
